import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import { Fab, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { openSnackbarAdviseAtom } from '../../../Atoms';
import SystemParametersListItems from './Components/SystemParametersListItems';
import useAPI from '../../../api';
import SystemParametersDialog from './Components/SystemParametersDialog';

const SystemParametersPage = function SystemParametersPage({ searchedValue }) {
  const intl = useIntl();
  const API = useAPI();
  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const [settings, setSettings] = useState(null);
  const [newDialog, setNewDialog] = useState(null);
  const [editDialog, setEditDialog] = useState(null);
  const [dialogId, setDialogId] = useState('');
  const [title, setTitle] = useState('');

  useEffect(() => {
    API.getSettings(
      (res) => {
        setSettings(res);
      },
      () => {
        setOpenSnackbarAdvise({
          message: intl.messages.ERROR_LOADING_SYSTEM_PARAMETER,
          severity: 'error',
        });
      }
    );
  }, []);

  const openNewSettingsDialog = () => {
    setDialogId('newSetting');
    setNewDialog(true);
  };

  const openEditSettingDialog = (setting) => {
    setDialogId('editSetting');
    setEditDialog(setting);
    setTitle(setting.settingName);
  };

  const closeSettingDialog = () => {
    setEditDialog(null);
    setNewDialog(null);
  };

  const handleNewSettingSubmit = (newSetting) => {
    const settingExists = settings.some(
      (item) => item.settingName === newSetting.settingName
    );

    if (settingExists) {
      setOpenSnackbarAdvise({
        message: intl.messages.EXISTING_SYSTEM_PARAMETER,
        severity: 'error',
      });
      return;
    }
    API.createSetting(
      newSetting,
      (newData) => {
        setOpenSnackbarAdvise({
          message: intl.messages.NEW_SYSTEM_PARAMETER_CREATE_SUCCESSFULLY,
          severity: 'success',
        });
        setSettings((prev) => [newData, ...prev]);
        setNewDialog(null);
      },
      (err) => {
        setOpenSnackbarAdvise({
          message: `${intl.messages.ERROR}: ${
            err?.status ? `${err?.status} - ` : ''
          } ${intl.messages.CREATE_SYSTEM_PARAMETER_ERROR}`,
          severity: 'error',
        });
      }
    );
  };

  const handleEditSubmit = (editSetting) => {
    API.editSetting(
      editSetting,
      (editData) => {
        setOpenSnackbarAdvise({
          message: intl.messages.SYSTEM_PARAMETER_EDITED_SUCCESSFULLY,
          severity: 'success',
        });
        setSettings((prev) =>
          prev.map((item) =>
            item.settingName === editData.settingName ? editData : item
          )
        );
        setEditDialog(null);
      },
      (err) => {
        setOpenSnackbarAdvise({
          message: `${intl.messages.ERROR}: ${
            err?.status ? `${err?.status} - ` : ''
          } ${intl.messages.EDITING_SYSTEM_PARAMETER_ERROR}`,
          severity: 'error',
        });
      }
    );
  };

  return (
    <div style={{ overflow: 'auto' }}>
      <Tooltip title={intl.messages.NEW_SYSTEM_PARAMETER}>
        <Fab
          color="primary"
          aria-label="add"
          onClick={openNewSettingsDialog}
          sx={{
            position: 'absolute',
            bottom: 30,
            right: 30,
          }}
        >
          <AddIcon />
        </Fab>
      </Tooltip>
      <SystemParametersListItems
        settings={settings}
        onClick={openEditSettingDialog}
        searchedValue={searchedValue}
      />
      <SystemParametersDialog
        dialogId={dialogId}
        title={intl.messages.NEW_SYSTEM_PARAMETER}
        open={Boolean(newDialog)}
        settings={newDialog}
        handleClose={closeSettingDialog}
        onSubmit={handleNewSettingSubmit}
      />
      <SystemParametersDialog
        dialogId={dialogId}
        title={title}
        open={Boolean(editDialog)}
        settings={editDialog}
        handleClose={closeSettingDialog}
        onSubmit={handleEditSubmit}
      />
    </div>
  );
};

export default SystemParametersPage;
